import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  Typography,
  useTheme
} from '@mui/material';

interface CancelSubscriptionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirmCancel: () => Promise<void>;
  isLoading: boolean;
}

const CancelSubscriptionDialog: React.FC<CancelSubscriptionDialogProps> = ({
  open,
  onClose,
  onConfirmCancel,
  isLoading
}) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Cancel Subscription</DialogTitle>
      <DialogContent>
        <Paper 
          elevation={0} 
          sx={{ 
            p: 2, 
            bgcolor: theme.palette.mode === 'dark' ? 'background.default' : '#fff9f9',
            borderRadius: 1,
            border: '1px solid',
            borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 0, 0, 0.2)' : theme.palette.error.light
          }}
        >
          <Typography variant="body1" color="error">
            Are you sure you want to cancel your subscription? Your subscription will remain active until the end of the current billing period.
          </Typography>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          No, Keep My Subscription
        </Button>
        <Button onClick={onConfirmCancel} color="error" disabled={isLoading}>
          {isLoading ? 'Processing...' : 'Yes, Cancel Subscription'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelSubscriptionDialog; 